import { graphql } from "../generated/gql";

export const AUTH = graphql(`
  query auth($email: String!, $password: String!) {
    auth(authInput: { email: $email, password: $password }) {
      accessToken
    }
  }
`);
